import { Decimal } from 'decimal.js';
import { isNil } from 'es-toolkit';
import { TOLERANCE, ZERO } from '../constants/constants';

export interface DiffersBeyondToleranceOptions {
  /** Tolerance to compare against. Defaults to {@link TOLERANCE} (0.01). */
  tolerance?: Decimal;
  /** When `true`, compares absolute values so that opposite signs are treated as equal. */
  ignoreSign?: boolean;
}

/**
 * Returns `true` when the absolute difference between `a` and `b` exceeds `tolerance`.
 * Both nil means equal (`false`); a single nil value is treated as ZERO.
 */
export function differsBeyondTolerance(
  a: Decimal | null | undefined,
  b: Decimal | null | undefined,
  options: DiffersBeyondToleranceOptions = {}
): boolean {
  if (isNil(a) && isNil(b)) return false;

  const { tolerance = TOLERANCE, ignoreSign = false } = options;
  const left = ignoreSign ? (a ?? ZERO).abs() : (a ?? ZERO);
  const right = ignoreSign ? (b ?? ZERO).abs() : (b ?? ZERO);
  return left.minus(right).abs().greaterThan(tolerance);
}
